import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, mergeMap } from 'rxjs';
import { TOKEN_TYPE } from 'src/app/auth/enums/token-type.enum';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../auth/services/auth/auth.service';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
  private readonly authService = inject(AuthService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const cachedToken = this.authService.authToken;

    if (cachedToken) {
      return this.setAuthToken(next, request, cachedToken);
    } else {
      return this.authService
        .getAuthToken()
        .pipe(
          mergeMap((deviceToken: string | null) =>
            this.setAuthToken(next, request, deviceToken)
          )
        );
    }
  }

  setAuthToken(
    next: HttpHandler,
    request: HttpRequest<unknown>,
    deviceToken: string | null
  ): Observable<HttpEvent<unknown>> {
    const hasDeviceToken = !!deviceToken;
    const isApiUrl = request.url.startsWith(environment.apiURL);

    if (isApiUrl) {
      let headers: HttpHeaders = request.headers.set(
        'Content-Type',
        'application/json'
      );

      if (hasDeviceToken) {
        headers = headers.set(TOKEN_TYPE.authorization, deviceToken);
      }

      request = request.clone({
        headers,
      });
    }

    return next.handle(request);
  }
}
